export default "__VITE_ASSET__B2aMXYOi__"